/* Rosela Nightly - quantity bundle, supply badge, and add-to-cart straight to checkout.

   The tiers are quantities of ONE variant, so there is no variant switching here: the only
   job is keeping the form's quantity field in step with the selected card. The price break
   itself comes from Shopify automatic BxGy discounts, which means the cart and checkout show
   a real discount line rather than the theme pretending a price.

   Two behaviours that exist because the button goes straight to checkout:
   - Back button: Safari and Chrome restore the page from the back-forward cache exactly as
     it was left, i.e. with the button disabled and reading "Taking you to checkout". The
     pageshow handler re-arms it.
   - Replace, don't stack: choosing a tier REPLACES this product's lines in the cart before
     adding. Someone who checks out with 2, comes back and picks 3 ends up with 3, not 5.

   Speed: measured click-to-checkout was ~2.8 s, of which ~1.45 s was three sequential cart
   requests (read, remove old lines, add) before the browser even started navigating. The
   cart is now read once at page load, and the click picks the shortest path that keeps the
   "replace, don't stack" promise:
     - cart empty (the usual case)      -> one /cart/add.js, then /checkout. Keeps the
                                           add-to-cart event the pixels listen for.
     - cart holds only this product     -> cart permalink, zero requests, replaces the lines.
     - cart holds something else, or unknown -> the careful three-step path as before.

   The submit handler is registered on document in the CAPTURE phase on purpose. Dawn binds
   its own submit listener to the form itself; a capture listener on an ancestor runs first,
   so stopPropagation here reliably takes over from the cart drawer. */
(function () {
  var ROOT = '[data-nightly-bundle]';
  var FORM = 'form[action*="/cart/add"]';

  function base() {
    try { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
    catch (e) { return '/'; }
  }

  function productForm() {
    var forms = document.querySelectorAll(FORM);
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('[name="id"]')) return forms[i];
    }
    return forms[0] || null;
  }

  /* Dawn only renders a quantity field when the template has a quantity block, and this
     template deliberately has none. Create a hidden one so /cart/add and the dynamic
     checkout buttons both see the chosen quantity. */
  function quantityField(form) {
    if (!form) return null;
    var el = form.querySelector('input[name="quantity"]');
    if (el) return el;
    el = document.createElement('input');
    el.type = 'hidden';
    el.name = 'quantity';
    el.value = '1';
    el.setAttribute('data-nightly-qty', '');
    form.appendChild(el);
    return el;
  }

  function selected(root) {
    var i = root.querySelector('input[name="nightly-qty"]:checked');
    return i ? parseInt(i.value, 10) || 1 : 1;
  }

  /* The badge lives INSIDE the first media card (Dawn's .product__media, the rounded box
     with the shadow), not on the outer wrapper. The wrapper is wider than the card, so a
     badge pinned to it hangs off the card's edge into the gutter; the card also clips to its
     own radius, which keeps the circle tidy. */
  function badgeHost() {
    return document.querySelector('.product__media-item.is-active .product__media') ||
           document.querySelector('.product__media-item .product__media') ||
           document.querySelector('.product__media') ||
           document.querySelector('.product__media-wrapper');
  }

  function badge(qty) {
    var media = badgeHost();
    if (!media) return;
    var el = document.querySelector('[data-nightly-badge]');
    if (el && el.parentNode !== media) { el.parentNode.removeChild(el); el = null; }
    if (!el) {
      if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
      el = document.createElement('div');
      el.className = 'n-badge';
      el.setAttribute('data-nightly-badge', '');
      el.setAttribute('aria-hidden', 'true');
      media.appendChild(el);
    }
    var months = qty * 2;
    el.textContent = '';
    var b = document.createElement('b');
    b.textContent = String(months);
    var s = document.createElement('span');
    s.textContent = 'Month supply';
    el.appendChild(b);
    el.appendChild(s);
  }

  function sync(root, field, qty) {
    if (field && field.value !== String(qty)) {
      field.value = String(qty);
      field.dispatchEvent(new Event('change', { bubbles: true }));
      field.dispatchEvent(new Event('input', { bubbles: true }));
    }
    badge(qty);
  }

  /* The closing section repeats the same three tiers as plain buttons. Clicking one has to
     land the customer on the buy box with that tier already chosen, otherwise they scroll
     back up and have to pick it a second time. */
  function jump(qty) {
    var root = document.querySelector(ROOT);
    if (!root) return;
    var input = root.querySelector('input[name="nightly-qty"][value="' + qty + '"]');
    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    sync(root, quantityField(productForm()), qty);

    var target = document.querySelector('.product__info-wrapper') || root;
    if (target.scrollIntoView) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    /* Move focus after the scroll settles so the chosen tier is announced and keyboard
       users continue from the buy box rather than from the bottom of the page. */
    if (input) {
      window.setTimeout(function () {
        try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
      }, 420);
    }
  }

  /* Button state. The resting label is remembered once so it can always be put back. */
  function submitButton(form) { return form ? form.querySelector('[name="add"]') : null; }
  function rememberLabel(form) {
    var btn = submitButton(form);
    var label = btn ? btn.querySelector('span') : null;
    if (btn && label && !btn.dataset.nbLabel) btn.dataset.nbLabel = label.textContent.trim();
  }
  function busy(form, on) {
    var btn = submitButton(form);
    var label = btn ? btn.querySelector('span') : null;
    if (!btn) return;
    if (on) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'Taking you to checkout';
    } else {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      if (label && btn.dataset.nbLabel) label.textContent = btn.dataset.nbLabel;
    }
  }

  function boot() {
    var root = document.querySelector(ROOT);
    if (!root || root.dataset.nbReady) return;
    root.dataset.nbReady = '1';

    var form = productForm();
    rememberLabel(form);
    var field = quantityField(form);
    sync(root, field, selected(root));

    root.addEventListener('change', function (e) {
      if (!e.target || e.target.name !== 'nightly-qty') return;
      sync(root, quantityField(productForm()), selected(root));
    });
    fromUrl(root);
  }

  /* Landing pages hand over a tier (tier=2) and, when a code was applied on the way in
     through /discount/CODE, the code name (code=NIGHTLY20) so the buy box can say so.
     Shopify keeps the code in the session and applies it at checkout on its own.
     The values ride in the URL FRAGMENT (#tier=2&code=NIGHTLY20), not the query string:
     Shopify's /discount/CODE?redirect= drops any query string from the redirect target,
     but browsers carry the fragment across the redirect untouched. Query string is read
     too, for links that come straight to the product page. */
  function fromUrl(root) {
    var q;
    try {
      q = new URLSearchParams(window.location.search);
      var h = new URLSearchParams((window.location.hash || '').replace(/^#/, ''));
      h.forEach(function (v, k) { q.set(k, v); });
    } catch (e) { return; }
    var tier = parseInt(q.get('tier'), 10);
    if (tier) {
      var input = root.querySelector('input[name="nightly-qty"][value="' + tier + '"]');
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    var code = (q.get('code') || '').replace(/[^A-Za-z0-9_-]/g, '').toUpperCase();
    if (!code || root.parentNode.querySelector('[data-nb-code]')) return;
    var p = document.createElement('p');
    p.setAttribute('data-nb-code', '');
    p.style.cssText = 'margin:-6px 0 14px;font-size:13px;color:#6b5518;text-align:center';
    p.textContent = code === 'NIGHTLY20'
      ? 'Code NIGHTLY20 is applied for you at checkout: an extra 20% off on top of the bundle price.'
      : 'Code ' + code + ' is applied for you at checkout.';
    root.insertAdjacentElement('afterend', p);
  }

  /* Delegated on document because the closing section can be re-rendered by the theme
     editor long after this file runs. */
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-nightly-jump]') : null;
    if (!el) return;
    var qty = parseInt(el.getAttribute('data-nightly-jump'), 10);
    if (!qty) return;
    e.preventDefault();
    jump(qty);
  });


  /* Cart knowledge, read once at load and again whenever the page is shown from the
     back-forward cache. It decides which of three checkout paths runs (see checkout()). */
  var cartState = null; /* Ajax cart object, or null while unknown */
  function readCart() {
    cartState = null;
    return fetch(base() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartState = c; return c; })
      .catch(function () { cartState = null; });
  }
  function cartHasOnly(pid) {
    if (!cartState || !cartState.items) return null;          /* unknown */
    for (var i = 0; i < cartState.items.length; i++) {
      if (cartState.items[i].product_id !== pid) return false; /* something else in there */
    }
    return true;                                                /* empty, or only this product */
  }
  function cartIsEmpty() { return !!(cartState && cartState.items && cartState.items.length === 0); }
  /* /cart/VARIANT:QTY[,VARIANT:QTY] makes Shopify build a fresh cart with exactly those
     lines and land on checkout in a single navigation. It replaces the whole cart, which is
     why it is only used when the cart holds nothing but this product. */
  function permalink(items) {
    return base() + 'cart/' + items.map(function (l) { return l.id + ':' + l.quantity; }).join(',');
  }

  /* Remove this product's existing lines so the chosen tier replaces rather than stacks.
     Best effort: any failure here falls through to a normal add. */
  function clearProduct(pid) {
    if (!pid) return Promise.resolve();
    return fetch(base() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {}, any = false;
        (cart.items || []).forEach(function (it) {
          if (it.product_id === pid) { updates[it.key] = 0; any = true; }
        });
        if (!any) return;
        return fetch(base() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .catch(function () {});
  }

  function checkout(form, root) {
    rememberLabel(form);
    busy(form, true);
    var pid = parseInt(root.getAttribute('data-product-id'), 10) || null;
    var body = new FormData(form);
    var idEl = form.querySelector('[name="id"]');
    var vid = idEl ? parseInt(idEl.value, 10) : 0;
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
    var only = pid ? cartHasOnly(pid) : null;

    if (vid && only === true && !cartIsEmpty()) {
      /* This product is already in the cart and nothing else is: the permalink swaps the
         lines for the chosen tier and goes straight to checkout. */
      window.location.href = permalink([{ id: vid, quantity: qty }]);
      return;
    }

    (cartIsEmpty() ? Promise.resolve() : clearProduct(pid))
      .then(function () {
        return fetch(base() + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body: body
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = base() + 'checkout'; })
      .catch(function () {
        /* Never strand the customer: hand the browser back a plain form post, which
           bypasses listeners and lands them on the cart. */
        busy(form, false);
        form.submit();
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches(FORM)) return;
    var root = document.querySelector(ROOT);
    if (!root) return;
    e.preventDefault();
    e.stopPropagation();
    checkout(form, root);
  }, true);

  /* Back from checkout: the page comes out of the back-forward cache mid-"busy". Re-arm. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var form = productForm();
    if (form) busy(form, false);
    readCart(); /* the cart changed at checkout; refresh what we know */
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  readCart();
})();
